import React from "react";
import "./Header.css";
import LanguageIcon from '@material-ui/icons/Language';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Avatar} from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search';
import {Link} from "react-router-dom";

function Header() {
  return <div className="header">
    <Link to="/">
      <img className="header__icon"
        src="https://upload.wikimedia.org/wikipedia/commons/6/69/Airbnb_Logo_B%C3%A9lo.svg"
        alt="logo here"
        />
    
    </Link>
      <div  className="header__center">

        <input type="text" name="" id=""/>
        <SearchIcon/>
      </div>
    <div className="header__right">
        <LanguageIcon/>
        <ExpandMoreIcon/>
        <Avatar/>
    </div>
  </div>;
}

export default Header;
